export type CoverageCallback = (result: string) => void;
